export default __webpack_public_path__ + "static/media/verySevereSmile.3f62ff82.svg";